import { JSEncrypt } from 'jsencrypt'

let cachedPublicKeyPem = null

async function getAmaPublicKeyPem () {
  if (cachedPublicKeyPem) return cachedPublicKeyPem
  const response = await fetch(process.env.REACT_APP_AMA_PUBLIC_KEY_URL)
  cachedPublicKeyPem = await response.text()
  return cachedPublicKeyPem
}

export async function encryptWithAmaKey (plaintext) {
  const pem = await getAmaPublicKeyPem()
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(pem)
  const result = encryptor.encrypt(plaintext)
  if (result === false) throw new Error('RSA PKCS1 encryption failed')
  return result
}
